"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var luxon_1 = require("luxon");
var core_components_1 = require("@securityproducts/core-components");
var DateRangeService = /** @class */ (function () {
    function DateRangeService(newRangeBehaviour) {
        this.dateTimeStore = core_components_1.DateAndTimeStore.getInstance();
        this.newRangeBehaviour = newRangeBehaviour;
        this.initRanges();
    }
    DateRangeService.getInstance = function (newRangeBehaviour) {
        if (newRangeBehaviour === void 0) { newRangeBehaviour = false; }
        if (DateRangeService.myInstance === null) {
            DateRangeService.myInstance = new DateRangeService(newRangeBehaviour);
        }
        return this.myInstance;
    };
    DateRangeService.prototype.initRanges = function () {
        this.today = {
            label: "Today",
            range: {
                fromDate: this.dateTimeStore.todayStart,
                toDate: luxon_1.DateTime.utc(),
            },
            period: {
                period: "DAYS",
                periodValue: 0,
            },
            interval: "HOURS",
        };
        this.yesterday = {
            label: "Yesterday",
            range: {
                fromDate: this.dateTimeStore.yesterdayStart,
                toDate: this.dateTimeStore.yesterdayEnd,
            },
            period: {
                period: "DAYS",
                periodValue: 1,
                periodOffset: 1,
            },
            interval: "HOURS",
        };
        this.lastThreeDays = {
            label: "Last 3 days",
            range: this.getRange("days", 3),
            period: {
                period: "DAYS",
                periodValue: 3,
            },
            interval: "DAYS",
        };
        this.lastFourteenDays = {
            label: "Last 14 days",
            range: this.getRange("days", 14),
            period: {
                period: "DAYS",
                periodValue: 14,
            },
            interval: "DAYS",
        };
        this.lastWeek = {
            label: "Last week",
            range: this.getLastWeekRange(),
            period: {
                period: "WEEKS",
                periodValue: 1,
                periodOffset: 1,
            },
            interval: "DAYS",
        };
        this.lastTwoWeeks = {
            label: "Last 2 weeks",
            range: this.getRange("weeks", 2),
            period: {
                period: "WEEKS",
                periodValue: 2,
                periodOffset: 1,
            },
            interval: "DAYS",
        };
        this.lastMonth = {
            label: "Last month",
            range: this.getLastMonthRange(),
            period: {
                period: "MONTHS",
                periodValue: 1,
                periodOffset: 1,
            },
            interval: "DAYS",
        };
        this.custom = {
            label: "Custom",
            range: undefined,
            period: undefined,
            interval: undefined,
        };
        this.archived = {
            label: "Archived",
            range: undefined,
            period: undefined,
            interval: undefined,
        };
        this.allRanges = [
            this.today,
            this.yesterday,
            this.lastThreeDays,
            this.lastFourteenDays,
            this.lastWeek,
            this.lastTwoWeeks,
            this.lastMonth,
            this.custom,
            this.archived,
        ];
        this.relativeRangeLabels = [
            this.today.label,
            this.yesterday.label,
            this.lastThreeDays.label,
            this.lastFourteenDays.label,
            this.lastWeek.label,
            this.lastTwoWeeks.label,
            this.lastMonth.label,
        ];
    };
    DateRangeService.prototype.getRangeFromLabel = function (label, timeRange) {
        // this may seem unnecessary but it means we can keep the API as consistent as
        // possible meaning the calling code doesn't need to go to such lengths to handle
        // the somewhat stranger case that is a 'Custom' range
        if (label === "Custom") {
            if (!timeRange) {
                throw new Error("You must supply a timeRange when getting the 'Custom' range");
            }
            return __assign(__assign({}, this.custom), { range: timeRange });
        }
        return this.allRanges.find(function (range) { return range.label === label; });
    };
    DateRangeService.prototype.getRangeFromPeriod = function (period) {
        return this.allRanges.find(function (range) {
            if (range.period.period === period.period) {
                if (range.period.periodValue === period.periodValue) {
                    return range.period.periodOffset === period.periodOffset;
                }
            }
        });
    };
    DateRangeService.prototype.getRange = function (period, value) {
        var _a;
        var duration = (_a = {}, _a[period] = value, _a);
        var fromDate = this.dateTimeStore.utcDateTime
            .set({
            hour: 0,
            minute: 0,
            second: 0,
        })
            .minus(duration);
        var toDate = this.newRangeBehaviour
            ? luxon_1.DateTime.utc()
            : this.dateTimeStore.yesterdayEnd.minus({ seconds: 59, milliseconds: 999 });
        return { fromDate: fromDate, toDate: toDate };
    };
    DateRangeService.prototype.getLastWeekRange = function () {
        if (this.newRangeBehaviour) {
            var pointInLastWeek = luxon_1.DateTime.local().minus({ days: 7 });
            // week starts on sunday the US
            var startOfLastWeek = pointInLastWeek.startOf("week").minus({ days: 1 });
            var endOfLastWeek = pointInLastWeek.endOf("week").minus({ days: 1 });
            return { fromDate: startOfLastWeek, toDate: endOfLastWeek };
        }
        else {
            return this.getRange("weeks", 1);
        }
    };
    DateRangeService.prototype.getLastMonthRange = function () {
        if (this.newRangeBehaviour) {
            var pointInLastMonth = luxon_1.DateTime.local().minus({ months: 1 });
            var startOfLastMonth = pointInLastMonth.startOf("month");
            var endOfLastMonth = pointInLastMonth.endOf("month");
            return { fromDate: startOfLastMonth, toDate: endOfLastMonth };
        }
        else {
            return {
                fromDate: this.dateTimeStore.lastMonth,
                toDate: this.dateTimeStore.yesterdayEnd.minus({ seconds: 59, milliseconds: 999 }),
            };
        }
    };
    DateRangeService.myInstance = null;
    return DateRangeService;
}());
exports.DateRangeService = DateRangeService;
